import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';

const LandingNavbar = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const { user } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { path: '/how-it-works', label: 'How it Works' },
    { path: '/clips', label: 'Clips' },
    { path: '/pricing', label: 'Pricing' },
  ];

  return (
    <nav className="border-b border-gray-200 dark:border-purple-800 bg-white/95 dark:bg-purple-950/95 backdrop-blur-md sticky top-0 z-50 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex items-center space-x-2 group flex-shrink-0">
              <SafeIcon icon={FiIcons.FiFeather} className="text-amber-600 dark:text-amber-500 text-2xl group-hover:rotate-12 transition-transform" />
              <span className="font-serif font-bold text-xl tracking-wide text-gray-900 dark:text-white">Weaver</span>
            </Link>

            {/* Desktop Nav Links */}
            <div className="hidden md:flex items-center space-x-6">
              {navLinks.map(({ path, label }) => (
                <Link
                  key={path}
                  to={path}
                  className="text-sm font-semibold text-gray-900 hover:text-amber-600 dark:text-purple-300 dark:hover:text-amber-500 transition-colors"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          {/* Right Side Controls */}
          <div className="flex items-center space-x-3">
            <Link
              to={user ? "/dashboard" : "/auth"}
              className="hidden sm:flex text-sm font-semibold text-gray-900 hover:text-amber-600 dark:text-purple-300 dark:hover:text-amber-500 transition-colors mr-2"
            >
              {user ? 'Storyboard' : 'Login'}
            </Link>
            <Link to={user ? "/setup/quiz" : "/auth"} className="hidden sm:flex btn-primary px-4 py-2 text-sm font-bold">
              Get Started
            </Link>

            {/* Theme Toggle */}
            <button
              onClick={toggleTheme}
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-purple-800 text-gray-900 dark:text-purple-400 transition-colors"
              title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
            >
              <SafeIcon icon={isDarkMode ? FiIcons.FiSun : FiIcons.FiMoon} />
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-purple-800 text-gray-900 dark:text-purple-400 transition-colors"
            >
              <SafeIcon icon={mobileOpen ? FiIcons.FiX : FiIcons.FiMenu} />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {mobileOpen && (
        <div className="md:hidden border-t border-gray-100 dark:border-purple-800 bg-white dark:bg-purple-950 px-4 py-3 space-y-1">
          {navLinks.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              onClick={() => setMobileOpen(false)}
              className="block px-3 py-2.5 rounded-lg text-sm font-semibold text-gray-900 hover:text-amber-600 dark:text-purple-300 dark:hover:text-amber-500 transition-colors"
            >
              {label}
            </Link>
          ))}
          <Link
            to={user ? "/dashboard" : "/auth"}
            className="block px-3 py-2.5 rounded-lg text-sm font-semibold text-gray-900 hover:text-amber-600 dark:text-purple-300 dark:hover:text-amber-500 transition-colors"
            onClick={() => setMobileOpen(false)}
          >
            {user ? 'Storyboard' : 'Login'}
          </Link>
          <Link to={user ? "/setup/quiz" : "/auth"} className="block w-full text-center mt-4 btn-primary px-4 py-2 text-sm font-bold" onClick={() => setMobileOpen(false)}>
            Get Started
          </Link>
        </div>
      )}
    </nav>
  );
};

export default LandingNavbar;
